import React from 'react';
import HORIZONTAL3 from './Layouts/HORIZONTAL3/layout.js';
import HORIZONTAL4 from './Layouts/HORIZONTAL4/layout.js';
import VERTICAL from './Layouts/VERTICAL/layout.js';
import CALLOUT from './Layouts/CALLOUT/layout.js';
import FILTER1 from './Layouts/FILTER1/layout.js';
import FEATURE from './Layouts/FEATURE/layout.js';

const Layouts={
	HORIZONTAL3:HORIZONTAL3,
	HORIZONTAL4:HORIZONTAL4,
	VERTICAL:VERTICAL,
	CALLOUT:CALLOUT,
	FILTER1:FILTER1,
	FEATURE:FEATURE
}

const PageLayout=(props)=>{
	let Layout=Layouts[props.layout];
	return (
		<Layout increment={props.increment} hide_content={props.hide_content}>
			{(props.sort===true
				?props.children.sort((a,b)=>{
					if(a.props.position===b.props.position)
						return 0;
					return (a.props.position>b.props.position?1:-1);
				})
				:props.children)}
		</Layout>
	);
}

export default PageLayout;





